export default __webpack_public_path__ + "static/media/Front-Cigar-Lounge.54d9f2d2.jpg";